import Vue from 'vue';
// import 'beautify-scrollbar/dist/index.css';
import V2LazyList from 'v2-lazy-list';

Vue.use(V2LazyList);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-lazyload.js
// module id = ./src/plugins/vue-lazyload.js
// module chunks = 34